// extracted by mini-css-extract-plugin
export default {"questionContainer":"styles_questionContainer__09cEc","footerStyles":"styles_footerStyles__+tujK","hidden":"styles_hidden__0rKtS"};